import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { navigateToHome } from 'app/routes';
import { ErrorDetailsDialog } from 'app/components/composite/ErrorDetailsDialog';
import { HTTP_NOT_FOUND, HTTP_FORBIDDEN } from 'app/middleware/constants';
import { translateError } from 'app/lib/error';

export const AppErrorOverlay = ({ onDismissError, error }) => {
    const { t } = useTranslation();

    const handleClose = useCallback(() => {
        if (error?.code === HTTP_NOT_FOUND || error?.code === HTTP_FORBIDDEN) {
            navigateToHome();
        }

        onDismissError();
    }, [onDismissError, error]);

    if (!error) {
        return null;
    }

    return (
        <ErrorDetailsDialog
            errorCode={error.code}
            message={translateError(t, error)}
            detail={error.detail}
            onClose={handleClose}
        />
    );
};
